import React from 'react';
import ExternalResources from '../CommonComponents/ExternalResources/ExternalResources';

const html = `<!DOCTYPE html>
<html lang="en-SG">

<head>
    
    <link rel="preload" as="script" href="https://www.owndays.com/web/js/line-liff-sdk.js?v=1.3">
    <script src="https://www.owndays.com/web/js/line-liff-sdk.js?v=1.3" type="text/javascript"></script>

    
    <script>
        if (window.location.href.indexOf('jp.owndays.com') != -1) {
            window.location.href = window.location.href.replace('jp.owndays.com', 'www.owndays.com')
        }
    </script>

                            
    <!-- Rtoaster -->
        <!-- /Rtoaster -->
    <!-- CleverTap -->
        <!-- /CleverTap -->
    
    <meta charset="utf-8">
     <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, minimal-ui">
        <meta name="format-detection" content="telephone=no">
    <link rel="apple-touch-icon" href="https://www.owndays.com/images/apple-touch-icon.png">
    <link rel="shortcut icon" type="image/x-icon" href="https://www.owndays.com/images/favicon.ico">
    <link rel="alternate" href="https://www.owndays.com/sg/en/" hreflang="en-SG">

<link rel="alternate" href="https://www.owndays.com/jp/ja/" hreflang="ja-JP">
<link rel="alternate" href="https://www.owndays.com/jp/en/" hreflang="en-JP">
<link rel="alternate" href="https://www.owndays.com/jp/zh_cn/" hreflang="zh-Hans-JP">
<link rel="alternate" href="https://www.owndays.com/jp/zh_tw/" hreflang="zh-Hant-JP">
<link rel="alternate" href="https://www.owndays.com/tw/zh_tw/" hreflang="zh-TW">
<link rel="alternate" href="https://www.owndays.com/th/th/" hreflang="th-TH">
<link rel="alternate" href="https://www.owndays.com/th/ja/" hreflang="ja-TH">
<link rel="alternate" href="https://www.owndays.com/th/en/" hreflang="en-TH">
<link rel="alternate" href="https://www.owndays.com/th/zh_cn/" hreflang="zh-Hans-TH">
<link rel="alternate" href="https://www.owndays.com/kh/km/" hreflang="km-KH">
<link rel="alternate" href="https://www.owndays.com/ph/en/" hreflang="en-PH">
<link rel="alternate" href="https://www.owndays.com/au/en/" hreflang="en-AU">
<link rel="alternate" href="https://www.owndays.com/my/en/" hreflang="en-MY">
<link rel="alternate" href="https://www.owndays.com/vn/vi/" hreflang="vi-VN">
<link rel="alternate" href="https://www.owndays.com/vn/en/" hreflang="en-VN">
<link rel="alternate" href="https://www.owndays.com/id/in/" hreflang="in-ID">
<link rel="alternate" href="https://www.owndays.com/hk/zh_hk/" hreflang="zh-HK">

    <!-- CSRF Token -->
    <meta name="csrf-token" content="3l2mZSSvEL3gN135hvod784zzYjCtQfEszb9JnUv">
    <meta property="og:locale" content="en_SG" />
    <meta name="locale-country" content="sg" />
    <meta name="locale-language" content="en" />
<meta property="og:site_name" content="OWNDAYS ONLINE STORE - OPTICAL SHOP">
    <meta property="og:type" content="website">
        <meta property="fb:app_id" content="221140811388378">
        <meta name="twitter:card" content="summary_large_image">
    <link rel="preconnect" href="https://ka-f.fontawesome.com">
    <link rel="preconnect" href="https://use.typekit.net">
    <link rel="preconnect" href="https://cdn.jsdelivr.net">
    <!-- Fonts -->
    <link rel="dns-prefetch" href="https://fonts.gstatic.com">
    <link rel="preload" href="https://www.owndays.com/fonts/owndays-icons.ttf?yotsy1" as="font">
    <link rel="preload" href="https://use.typekit.net/qdz8arm.css" as="style">
    <link rel="stylesheet" href="https://use.typekit.net/qdz8arm.css">
    <!-- Images -->
    <link rel="preload" as="image" href="https://www.owndays.com/images/svg/owndays.svg">
    <!-- Styles -->
    
    
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css">
<link href="https://www.owndays.com/web/css/specials-mi-mollet.css" rel="stylesheet">
        <link rel="preload" href="https://www.owndays.com/web/css/sg/en.css" as="style">
        <link href="https://www.owndays.com/web/css/sg/en.css" rel="stylesheet">
            <link rel="preload" href="https://www.owndays.com/web/css/sg/en.css" as="style">
        <link href="https://www.owndays.com/web/css/sg/en.css" rel="stylesheet">
            <!-- fontawesome 5.x -->
    
    
        <link rel="preload" as="script" href="https://www.owndays.com/web/js/apis.google-platform.js">
    <script src="https://www.owndays.com/web/js/apis.google-platform.js" type="text/javascript"></script>
    <link rel="preload" as="script" href="https://www.owndays.com/web/js/google-pay-sdk.js?v=1.2">
    <script src="https://www.owndays.com/web/js/google-pay-sdk.js?v=1.2" type="text/javascript" onload="window.google_pay_loaded = true"></script>
        <!-- If open with LINE show the title only name "OWNDAYS" -->
</head>

<!-- If open with LINE add class ".is-line-mini" to body tag -->

<body id="main-body" style="display: block" class="is-sale-time">

                <div id="app" data-nosnippet>



<!-- header - SP電話モーダル中身 -->
<modal class="l-header__modal" id="contact" style="display: none;">
    <p class="l-header__modal-title">Contact Us</p>
    <div class="contact-information"><a id="header_modal_contact" href="tel:6222-0588"><span class="icon-tel"></span>6222-0588</a></div>
    <p><span>Operating Hours</span> <span>10:00 - 19:00</span></p>
        <div class="c-btn c-btn--tertiary c-btn--tertiary-center u-mt__10">
        <a href="/sg/en/faq">FAQs</a>
    </div>
        <p class="c-attention"></p>
    </modal>

                <main class="l-content
        
        
        
        
        
        ">
            <div class="od-c-breadcrumb">
    <ul id="breadcrumb-list">
                <li>
                                                 
                                                    <a href="/sg/en/news">News</a>
                                                                                </li>
                <li>
                            mi-mollet × OWNDAYS                    </li>
        
            </ul>
</div>



<section class="l-mi-mollet">
    <section class="l-mi-mollet__top">
        <div class="l-mi-mollet__top-inner">
            <h1 class="l-mi-mollet__top-title">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/OWNDAYSxmi-mollet.svg" alt="OWNDAYS x mi-mollet">
            </h1>
            <!-- <p class="l-mi-mollet__top-subtitle">
                <span>12/08/2021<small>Thur</small></span><span>Online and In-Store Launch</span>
            </p> -->
        </div>
        <div class="l-mi-mollet__top-content">
            <div class="l-mi-mollet__top-slider">
                <div class="l-mi-mollet__top-slider-item">
                    <img src="https://www.owndays.com/images/specials/products/mi-mollet/top-img-1_sp.webp" alt="">
                </div>
                <div class="l-mi-mollet__top-slider-item">
                    <img src="https://www.owndays.com/images/specials/products/mi-mollet/top-img-2_sp.webp" alt="">
                </div>
                <div class="l-mi-mollet__top-slider-item">
                    <img src="https://www.owndays.com/images/specials/products/mi-mollet/top-img-3_sp.webp" alt="">
                </div>
            </div>
            <div class="l-mi-mollet__top-img">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/top-img_pc.webp" alt="">
            </div>
            <h2 class="l-mi-mollet__top-heading">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/sg/top-heading.svg" alt="">
            </h2>
        </div>
        <a data-scroll href="#message" class="l-mi-mollet__top-scroll">
            <span class="l-mi-mollet__top-scroll-text">SCROLL</span>
            <div class="l-mi-mollet__btn-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53">
                    <g id="btn-circle" transform="translate(0 0.479)">
                        <g id="circle" transform="translate(0 -0.479)" fill="none">
                            <path d="M26.5,0A26.5,26.5,0,1,1,0,26.5,26.5,26.5,0,0,1,26.5,0Z" stroke="none" />
                            <path d="M 26.5 1 C 23.05707931518555 1 19.71768188476562 1.674079895019531 16.57455825805664 3.003509521484375 C 13.53815841674805 4.287799835205078 10.81098175048828 6.126579284667969 8.468780517578125 8.468780517578125 C 6.126579284667969 10.81098175048828 4.287799835205078 13.53815841674805 3.003509521484375 16.57455825805664 C 1.674079895019531 19.71768188476562 1 23.05707931518555 1 26.5 C 1 29.94292068481445 1.674079895019531 33.28231811523438 3.003509521484375 36.42543792724609 C 4.287799835205078 39.46183776855469 6.126579284667969 42.18901824951172 8.468780517578125 44.53121948242188 C 10.81098175048828 46.87342071533203 13.53815841674805 48.71220016479492 16.57455825805664 49.99649047851562 C 19.71768188476562 51.32592010498047 23.05707931518555 52 26.5 52 C 29.94292068481445 52 33.28231811523438 51.32592010498047 36.42543792724609 49.99649047851562 C 39.46183776855469 48.71220016479492 42.18901824951172 46.87342071533203 44.53121948242188 44.53121948242188 C 46.87342071533203 42.18901824951172 48.71220016479492 39.46183776855469 49.99649047851562 36.42543792724609 C 51.32592010498047 33.28231811523438 52 29.94292068481445 52 26.5 C 52 23.05707931518555 51.32592010498047 19.71768188476562 49.99649047851562 16.57455825805664 C 48.71220016479492 13.53815841674805 46.87342071533203 10.81098175048828 44.53121948242188 8.468780517578125 C 42.18901824951172 6.126579284667969 39.46183776855469 4.287799835205078 36.42543792724609 3.003509521484375 C 33.28231811523438 1.674079895019531 29.94292068481445 1 26.5 1 M 26.5 0 C 41.13554000854492 0 53 11.86445999145508 53 26.5 C 53 41.13554000854492 41.13554000854492 53 26.5 53 C 11.86445999145508 53 0 41.13554000854492 0 26.5 C 0 11.86445999145508 11.86445999145508 0 26.5 0 Z" stroke="none" fill="#fff" />
                        </g>
                        <path id="arrow" d="M10.387,5V15M5,10.387l5.387,5.387,5.387-5.387" transform="translate(15.828 15.943)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" />
                    </g>
                </svg>
            </div>
        </a>
    </section>
    <section class="l-mi-mollet__message" id="message">
        <div class="l-mi-mollet__inner">
            <div class="l-mi-mollet__message-details">
                <h2 class="l-mi-mollet__message-title ff-m3c">Message</h2>
                <div class="l-mi-mollet__message-text">
                    <p class="l-mi-mollet__message-text--sub">
                        Longing for Adulthood</p>
                    <p class="l-mi-mollet__message-text--strong">
                        “Adult Glasses”<br></p>
                    <p>
                        The desire to look fashionable.<br>The desire to look smart.<br>The desire to look effortless.<br><br>Glasses that answer your longing for adulthood,<br>creating a look that brims with maturity and sensibility.<br><br>Much like eye makeup that enhances your features.<br><br>Comes with a crossbody pouch that holds your glasses,<br>mobile phone and other small items,<br>making it a perfect accessory to keep your hands free while looking all stylish.                    </p>
                </div>
            </div>
        </div>
    </section>
    <section class="l-mi-mollet__lineup">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__lineup-title">Line Up<small>Full Collection</small></h2>
            <p class="l-mi-mollet__lineup-subtitle">12 types in 3 styles / S$218.00<small></small></p>
            <ul class="l-mi-mollet__lineup-list">
                <li>
                    <div class="l-mi-mollet__lineup-item">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_01.jpg" alt="MI2001J-1A C2">
                        <h5>Relaxing Day Off</h5>
                        <p>Be Yourself on your<br>Day Off</p>
                        <a href="#story1">
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/arrow-down-circle.svg" alt="">
                        </a>
                    </div>
                </li>
                <li>
                    <div class="l-mi-mollet__lineup-item">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_01.jpg" alt="MI2002J-1A C4">
                        <h5>Lunch Date with Friends</h5>
                        <p>Dress up for a<br>lunch date with friends</p>
                        <a href="#story2">
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/arrow-down-circle.svg" alt="">
                        </a>
                    </div>
                </li>
                <li>
                    <div class="l-mi-mollet__lineup-item">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_01.jpg" alt="MI1001B-1A C3">
                        <h5>Back at Work</h5>
                        <p>Sophistication at<br>Work</p>
                        <a href="#story3">
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/arrow-down-circle.svg" alt="">
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </section>
    <!-- Set 1 -->
    <section class="l-mi-mollet__story" id="story1">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__story-title">Relaxing<br>Day<br>Off</h2>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--1">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-1.webp" alt="">
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--2">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-2.webp" alt="">
                <a href="#modalSstItem" data-toggle="modal" class="link-window">VIEW MORE</a>
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--3">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-3.webp" alt="">
            </div>
            <p class="l-mi-mollet__story-text">Indulge in some me-time on your day off<br>
                Have a good read by yourself at a café<br>
                Throw on a full-rim frame to add a touch of cuteness<br>
                Be yourself while looking well put-together</p>
        </div>
    </section>
    <section class="l-mi-mollet__point">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__point-title">Point<small>Features</small></h2>
            <div class="l-mi-mollet__point-slider">
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_02.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">01</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">6mm-thick material to<br>create a vivid impression</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_05.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">02</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Temples double as decorative accents<br>with the wire core encased in transparent acetate</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_07.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">03</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Star motif added on the left temple tip<br>as a design element</p>
                </div>
            </div>
        </div>
    </section>
    <section class="l-mi-mollet__products">
        <div class="l-mi-mollet__inner">
            <ul class="l-mi-mollet__products-grid">
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C1_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2001J-1A C1 / Black</h5>
                    <a href="/sg/en/products/MI2001J-1A?sku=5451" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C2_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2001J-1A C2 / Brown</h5>
                    <a href="/sg/en/products/MI2001J-1A?sku=5452" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C3_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2001J-1A C3 / Light Khaki</h5>
                    <a href="/sg/en/products/MI2001J-1A?sku=5453" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2001J-1A_C4_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2001J-1A C4 / Light Beige</h5>
                    <a href="/sg/en/products/MI2001J-1A?sku=5454" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
            </ul>
        </div>
    </section>
    <!-- Set 2 -->
    <section class="l-mi-mollet__story l-mi-mollet__story--2" id="story2">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__story-title">Lunch Date<br>with<br>Friends</h2>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--1">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-4.webp" alt="">
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--2">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-5.webp" alt="">
                <!-- <a href="#modalSstItem" data-toggle="modal">VIEW MORE</a> -->
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--3">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-6.webp" alt="">
            </div>
            <p class="l-mi-mollet__story-text">Dress up for a lunch date with friends<br>
                Go for a metal frame with elegant Cloisonné accents<br>
                Shining brightly like a prized jewellery<br>
                Elevating your confidence that flows from within            </p>
        </div>
    </section>
    <section class="l-mi-mollet__point">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__point-title">Point<small>Features</small></h2>
            <div class="l-mi-mollet__point-slider">
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_02.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">01</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Using titanium for the front<br>to keep frame weight at its minimum</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_05.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">02</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Adopting the Cloisonné enamel technique <br>to add depth to the frame front</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_07.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">03</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Star motif added on the left temple tip<br>as a design element</p>
                </div>
            </div>
        </div>
    </section>
    <section class="l-mi-mollet__products">
        <div class="l-mi-mollet__inner">
            <ul class="l-mi-mollet__products-grid">
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C1_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI1001B-1A C1 / Black</h5>
                    <a href="/sg/en/products/MI1001B-1A?sku=5459" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C2_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI1001B-1A C2 / Brown</h5>
                    <a href="/sg/en/products/MI1001B-1A?sku=5460" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C3_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI1001B-1A C3 / Khaki</h5>
                    <a href="/sg/en/products/MI1001B-1A?sku=5461" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI1001B-1A_C4_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI1001B-1A C4 / Wine</h5>
                    <a href="/sg/en/products/MI1001B-1A?sku=5462" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
            </ul>
        </div>
    </section>
    <!-- Set 3 -->
    <section class="l-mi-mollet__story l-mi-mollet__story--3" id="story3">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__story-title">Back<br>at<br>Work</h2>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--1">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-7.webp" alt="">
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--2">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-8.webp" alt="">
                <!-- <a href="#modalSstItem" data-toggle="modal">VIEW MORE</a> -->
            </div>
            <div class="l-mi-mollet__story-img l-mi-mollet__story-img--3">
                <img src="https://www.owndays.com/images/specials/products/mi-mollet/story-img-9.webp" alt="">
            </div>
            <p class="l-mi-mollet__story-text">Sophistication at Work<br>
                Look sharp while you are at work<br>
                With a dual-material frame that accentuates your eyes<br>
                A clever balance of fashion and sophistication<br>
                That says you mean business            </p>
        </div>
    </section>
    <section class="l-mi-mollet__point">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__point-title">Point<small>Features</small></h2>
            <div class="l-mi-mollet__point-slider">
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_05.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">01</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Metal bridge with intricate engraving<br>to add a timeless appeal</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_03.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">02</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Slim temples that create<br>a sleek silhouette</p>
                </div>
                <div class="l-mi-mollet__point-item">
                    <div class="l-mi-mollet__point-item-img">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_07.jpg" alt="">
                        <h5 class="l-mi-mollet__point-item-number">03</h5>
                    </div>
                    <p class="l-mi-mollet__point-item-text">Star motif added on the left temple tip<br>as a design element</p>
                </div>
            </div>
        </div>
    </section>
    <section class="l-mi-mollet__products">
        <div class="l-mi-mollet__inner">
            <ul class="l-mi-mollet__products-grid">
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C1_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2002J-1A C1 / Black</h5>
                    <a href="/sg/en/products/MI2002J-1A?sku=5455" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C2_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2002J-1A C2 / Brown Demi</h5>
                    <a href="/sg/en/products/MI2002J-1A?sku=5456" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C3_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2002J-1A C3 / Gray</h5>
                    <a href="/sg/en/products/MI2002J-1A?sku=5457" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
                <li class="l-mi-mollet__products-item">
                    <div class="l-mi-mollet__products-img">
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_01.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_02.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_03.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_04.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_05.jpg" alt="">
                        </div>
                        <div>
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/MI2002J-1A_C4_06.jpg" alt="">
                        </div>
                    </div>
                    <h5 class="l-mi-mollet__products-title">MI2002J-1A C4 / Light Beige</h5>
                    <a href="/sg/en/products/MI2002J-1A?sku=5458" class="l-mi-mollet__btn">Purchase Online / S$218.00</a>
                </li>
            </ul>
        </div>
    </section>
    <section class="l-mi-mollet__case">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__case-title">Original Case &<br>Cleaning Cloth Set</h2>
            <p class="l-mi-mollet__case-subtitle">Spectacle Pouch & Cleaning Cloth Set</p>
                        <div class="l-mi-mollet__case-img">
                <div class="l-mi-mollet__case-slider">
                    <div>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_9.webp" alt="">
                    </div>
                    <div>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_3.webp" alt="">
                    </div>
                    <div>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_4.webp" alt="">
                    </div>
                    <div>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_6.webp" alt="">
                    </div>
                    <div>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_5.webp" alt="">
                    </div>
                    <div class="jp-none">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet_1.webp" alt="">
                    </div>
                </div>
            </div>
            <p class="l-mi-mollet__case-text">Featuring an adjustable shoulder strap with an iconic gold ring embellishment and a smaller case for your daily essentials like lipsticks and earphones, this spectacle pouch set is the perfect accessory to the “One-Mile Wear” dressing. The pouch takes on a minimalist design that can go with any outfit while retaining a subtle touch of cuteness. It also doubles up as a phone case when you are out wearing your spectacles. A limited-edition spectacle cloth is included in the set. </p>
                    </div>

    </section>
    <section class="l-mi-mollet__bottom">
        <div class="l-mi-mollet__inner">
            <div class="l-mi-mollet__bottom-stylist">
                <picture>
                    <source media="(min-width: 768px)" srcset="https://www.owndays.com/images/specials/products/mi-mollet/stylist_pc.webp">
                    <img src="https://www.owndays.com/images/specials/products/mi-mollet/stylist_sp.webp" alt="" class="l-mi-mollet__bottom-stylist-img">
                </picture>
                <div class="l-mi-mollet__bottom-stylist-details">
                    <div class="l-mi-mollet__bottom-stylist-details--text">
                        <h2><small>Stylist</small><span>Naoko Okusa<a href="https://www.instagram.com/naokookusa/" target="_blank" rel="noopener noreferrer"><img src="https://www.owndays.com/images/specials/products/mi-mollet/icon-instagram-black.svg" alt=""></a></span></h2>
                        <p>
                            Naoko started her career as an editor and is currently one of the most prominent fashion stylists in Japan. She has served as the editor-in-chief of the web magazine "mi-mollet" since 2015 as well as its concept director since July 2018. Besides styling and journalism, Naoko is also actively involved in directing ad campaigns and is a frequent speaker at events and an author. She is a mother of three children.                         </p>
                    </div>
                    <a href="https://mi-mollet.com/" target="_blank" rel="noopener noreferrer" class="l-mi-mollet__bottom-stylist-details--link">
                        <span>mi-mollet OFFICIAL SITE</span>
                        <svg id="btn-circle" xmlns="http://www.w3.org/2000/svg" width="67.251" height="67.251" viewBox="0 0 67.251 67.251">
                            <g id="circle" fill="none">
                                <path d="M33.626,0A33.626,33.626,0,1,1,0,33.626,33.626,33.626,0,0,1,33.626,0Z" stroke="none" />
                                <path d="M 33.6256103515625 1 C 29.22074127197266 1 24.94816207885742 1.862480163574219 20.92655944824219 3.563468933105469 C 17.04164123535156 5.206649780273438 13.55242156982422 7.559219360351562 10.55582046508789 10.55582046508789 C 7.559219360351562 13.55242156982422 5.206649780273438 17.04164123535156 3.563468933105469 20.92655944824219 C 1.862480163574219 24.94816207885742 1 29.22074127197266 1 33.6256103515625 C 1 38.03047943115234 1.862480163574219 42.30306243896484 3.563468933105469 46.32466125488281 C 5.206649780273438 50.20957946777344 7.559219360351562 53.69879913330078 10.55582046508789 56.69540023803711 C 13.55242156982422 59.69200134277344 17.04164123535156 62.04457092285156 20.92655944824219 63.68775177001953 C 24.94816207885742 65.38874053955078 29.22074127197266 66.251220703125 33.6256103515625 66.251220703125 C 38.03047943115234 66.251220703125 42.30306243896484 65.38874053955078 46.32466125488281 63.68775177001953 C 50.20957946777344 62.04457092285156 53.69879913330078 59.69200134277344 56.69540023803711 56.69540023803711 C 59.69200134277344 53.69879913330078 62.04457092285156 50.20957946777344 63.68775177001953 46.32466125488281 C 65.38874053955078 42.30306243896484 66.251220703125 38.03047943115234 66.251220703125 33.6256103515625 C 66.251220703125 29.22074127197266 65.38874053955078 24.94816207885742 63.68775177001953 20.92655944824219 C 62.04457092285156 17.04164123535156 59.69200134277344 13.55242156982422 56.69540023803711 10.55582046508789 C 53.69879913330078 7.559219360351562 50.20957946777344 5.206649780273438 46.32466125488281 3.563468933105469 C 42.30306243896484 1.862480163574219 38.03047943115234 1 33.6256103515625 1 M 33.6256103515625 0 C 52.1965217590332 0 67.251220703125 15.0546989440918 67.251220703125 33.6256103515625 C 67.251220703125 52.1965217590332 52.1965217590332 67.251220703125 33.6256103515625 67.251220703125 C 15.0546989440918 67.251220703125 0 52.1965217590332 0 33.6256103515625 C 0 15.0546989440918 15.0546989440918 0 33.6256103515625 0 Z" stroke="none" fill="#000" />
                            </g>
                            <path id="arrow-down" d="M11.913,5V17.838M5,11.913l6.913,6.913,6.913-6.913" transform="translate(21.728 21.728)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" />
                        </svg>

                    </a>
                </div>
            </div>
            <div class="l-mi-mollet__bottom-about">
                <h2>
                    <span>
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/mi-mollet.svg" alt="">
                        <small></small>
                    </span>
                </h2>
                
                                <p>I’d been earnestly looking out for something in the last few years,<br>
                    always pondering where to get it, how it should fit,<br>
                    at what price should I pay for it…That something was in fact a pair of spectacles.<br>
                    <br>
                    It wasn’t just any regular pair of spectacles that I was looking for. It was a pair of reading glasses!<br>
                    I had perfect eyesight but the time had come and it was increasingly difficult for me to look at restaurant menus and even my mobile phone with much clarity.<br>
                    <br>
                    Looking back now, I realise that I began feeling anxious around my mid-40s. There were many uncertainties and anxieties.<br>
                    <br>
                    As I wasn’t able to find the solution, I decided to make my own – spectacles that aid your vision,<br>
                    are versatile and readily available and are made of interesting materials, colours and forms.<br>
                    The problem of not being able to see clearly was the initial catalyst behind this project<br>
                    and I’m very pleased with the outcome comprising these very stylish frames.<br>
                    How I wish I had come up with the idea earlier!<br>
                    So yes, it’s finally done!<br>
                    OWNDAYS has turned my idea into form.<br>
                    I’ve been a fan of OWNDAYS sunglasses, but these spectacle frames are just beyond perfect.<br>
                    They are what I’d call “Adult Glasses” and I’m so proud of them.<br>
                    Of course, they are not just reading glasses.<br>
                    You can use the frames with any type of lenses that meets your needs ♡                </p>
                            </div>
            <div class="l-mi-mollet__bottom-notes">
                <h2 class="l-mi-mollet__bottom-notes-title">Notes<small>Terms & Conditions</small></h2>
                <div class="l-mi-mollet__bottom-notes-details">
                    <ul>
                        <li>Products are covered under warranty. Please see <a href="/sg/en/services/warranty" class="link-color-blue u-dib"> OWNDAYS Customer Guarantees page </a> for more details</li>
                        <li>Resale or transfer is strictly prohibited<br class="u-sp-only">Delivery within Singapore only</li>
                        <li>Upgrade to optional lenses is available at a top-up fee</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

        <section class="l-mi-mollet__shops" id="available-shop">
        <h2 class="l-mi-mollet__shops-title">Outlets Available</h2>
        <ul class="l-mi-mollet__inner">
            <li>
                <a href="/sg/en/shops/905">・OWNDAYS Plaza Singapura</a>
            </li>
            <li>
                <a href="/sg/en/shops/920">・OWNDAYS ION Orchard</a>
            </li>
            <li>
                <a href="/sg/en/shops/924">・OWNDAYS Suntec city mall</a>
            </li>
            <li>
                <a href="/sg/en/shops/927">・OWNDAYS White Sands</a>
            </li>
            <li>
                <a href="/sg/en/shops/937">・OWNDAYS Tiong bahru plaza</a>
            </li>
            <li>
                <a href="/sg/en/shops/948">・OWNDAYS Compass One</a>
            </li>
            <li>
                <a href="/sg/en/shops/962">・OWNDAYS Westgate</a>
            </li>
            <li>
                <a href="/sg/en/shops/965">・OWNDAYS Clementi Mall</a>
            </li>
            <li>
                <a href="/sg/en/shops/974">・OWNDAYS Seletar Mall</a>
            </li>
            <li>
                <a href="/sg/en/shops/977">・OWNDAYS Bukit Panjang Plaza</a>
            </li>
            <li>
                <a href="/sg/en/shops/983">・OWNDAYS Century Square</a>
            </li>
            <li>
                <a href="/sg/en/shops/994">・OWNDAYS PLQ Mall</a>
            </li>
            <li>
                <a href="/sg/en/shops/1004">・OWNDAYS Raffles city New</a>
            </li>
            <li>
                <a href="/sg/en/shops/1006">・OWNDAYS Parkway Parade</a>
            </li>
        </ul>
    </section>
    
    
    <section class="l-mi-mollet__sns">
        <div class="l-mi-mollet__inner">
            <h2 class="l-mi-mollet__sns-title">SNS</h2>
            <ul class="l-mi-mollet__sns-list">
                <li>
                    <a href="https://twitter.com/intent/tweet?url=https://www.owndays.com/sg/en/news/mi-mollet" target="_blank" rel="noopener noreferrer">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/icon-twitter.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.owndays.com/sg/en/news/mi-mollet" target="_blank" rel="noopener noreferrer">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/icon-facebook.svg" alt="">
                    </a>
                </li>
                <li>
                    <a href="http://line.me/R/msg/text/?https://www.owndays.com/sg/en/news/mi-mollet" target="_blank" rel="noopener noreferrer">
                        <img src="https://www.owndays.com/images/specials/products/mi-mollet/icon-line.svg" />
                    </a>
                </li>
            </ul>
        </div>
        <div class="l-mi-mollet__sns-copyright">Copyright c 2021 Kodansha ltd. All rights reserved.</div>
    </section>

    <!-- Modal / Set Item -->
    <div class="modal fade l-mi-mollet__story-modal" id="modalSstItem" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="https://www.owndays.com/images/icons/close-1.png" alt="">
                    </button>
                    <div class="l-mi-mollet__story-modal-images">
                        <div class="l-mi-mollet__story-modal-img l-mi-mollet__story-modal-img--1">
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/set-item-1.webp" alt="">
                            <p>Pouch</p>
                        </div>
                        <div class="l-mi-mollet__story-modal-img l-mi-mollet__story-modal-img--2">
                            <img src="https://www.owndays.com/images/specials/products/mi-mollet/set-item-2.webp" alt="">
                            <p>Cleaning Cloth</p>
                        </div>
                    </div>
                    <div class="l-mi-mollet__story-modal-details">
                        <h5>SET ITEM</h5>
                        <p>Featuring an adjustable shoulder strap with an iconic gold ring embellishment and a smaller case for your daily essentials like lipsticks and earphones, this spectacle pouch set is the perfect accessory to the “One-Mile Wear” dressing. The pouch takes on a minimalist design that can go with any outfit while retaining a subtle touch of cuteness. It also doubles up as a phone case when you are out wearing your spectacles. A limited-edition spectacle cloth is included in the set. </p>
                        <p class="note jp-none">*Comes with all mi-mollet frames</p>
                                            </div>
                </div>
            </div>
        </div>
    </div>
</section>

        </main>
            </div>

  
    
    <!-- /top-return -->
<div id="top-btn" class="c-top-btn">
    <img class="lazyload" data-src="https://www.owndays.com/images/svg/arrow-top.svg" alt="TOP">
    <p>TOP</p>
</div>



<!-- Modal / Country & Language -->
<div class="modal fade l-modal__country-lang" tabindex="-1" id="modalCountryLang">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img class="lazyload" data-src="https://www.owndays.com/images/icons/close-1.png" alt="Close">
                </button>
                <p class="modal-title">Choose your country</p>
                <div id="accordionCountryLang" class="modal-accordion accordion">
                    <!-- For Mobile -->
                    <ul class="modal-list u-sp-only">
                                                <li class="modal-list-item">
                                                        <button type="button" data-target="#countryjp" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/jp.webp" type="image/webp">
                                    
                                </picture>
                                日本
                            </button>
                            <ul class="modal-list-lang collapse" id="countryjp" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/jp/ja" class="">
                                        日本語
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/en" class="">
                                        English
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/zh_cn" class="">
                                        中文 (简体)
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/zh_tw" class="">
                                        中文 (繁體)
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <button type="button" data-target="#countrysg" class="modal-list-country active" data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/sg.webp" type="image/webp">
                                    
                                </picture>
                                SINGAPORE
                            </button>
                            <ul class="modal-list-lang collapse" id="countrysg" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/sg/en" class="active">
                                        English
                                    </a>
                                </li>
                                                                
                                                                
                                                            </ul>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/tw/zh_tw" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/tw.webp" type="image/webp">
                                    
                                </picture>
                                台灣
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <button type="button" data-target="#countryth" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/th.webp" type="image/webp">
                                    
                                </picture>
                                ไทย
                            </button>
                            <ul class="modal-list-lang collapse" id="countryth" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/th/th" class="">
                                        ภาษาไทย
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/en" class="">
                                        English
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/ja" class="">
                                        日本語
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/zh_cn" class="">
                                        中文 (简体)
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/kh/km" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/kh.webp" type="image/webp">
                                    
                                </picture>
                                ព្រះរាជាណាចក្រ
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/ph/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/ph.webp" type="image/webp">
                                    
                                </picture>
                                PHILIPPINES
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/au/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/au.webp" type="image/webp">
                                    
                                </picture>
                                AUSTRALIA
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/my/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/my.webp" type="image/webp">
                                    
                                </picture>
                                MALAYSIA
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <button type="button" data-target="#countryvn" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/vn.webp" type="image/webp">
                                    
                                </picture>
                                Việt Nam
                            </button>
                            <ul class="modal-list-lang collapse" id="countryvn" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/vn/vi" class="">
                                        Tiếng Việt
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/vn/en" class="">
                                        English
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/id/in" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/id.webp" type="image/webp">
                                    
                                </picture>
                                INDONESIA
                            </a>
                                                    </li>
                                                <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/hk/zh_hk" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/hk.webp" type="image/webp">
                                    
                                </picture>
                                香港
                            </a>
                                                    </li>
                                            </ul>

                    <!-- For Desktop -->
                     <ul class="modal-list u-pc-only">
                                                                                                                        <li class="modal-list-item">
                                                        <button type="button" data-target="#countryjp" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/jp.webp" type="image/webp">
                                    
                                </picture>
                                日本
                            </button>
                            <ul class="modal-list-lang collapse" id="countryjp" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/jp/ja" class="">
                                        日本語
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/en" class="">
                                        English
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/zh_cn" class="">
                                        中文 (简体)
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/jp/zh_tw" class="">
                                        中文 (繁體)
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/tw/zh_tw" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/tw.webp" type="image/webp">
                                    
                                </picture>
                                台灣
                            </a>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/kh/km" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/kh.webp" type="image/webp">
                                    
                                </picture>
                                ព្រះរាជាណាចក្រ
                            </a>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/au/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/au.webp" type="image/webp">
                                    
                                </picture>
                                AUSTRALIA
                            </a>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <button type="button" data-target="#countryvn" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/vn.webp" type="image/webp">
                                    
                                </picture>
                                Việt Nam
                            </button>
                            <ul class="modal-list-lang collapse" id="countryvn" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/vn/vi" class="">
                                        Tiếng Việt
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/vn/en" class="">
                                        English
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/hk/zh_hk" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/hk.webp" type="image/webp">
                                    
                                </picture>
                                香港
                            </a>
                                                    </li>
                                                </ul>
                         <ul class="modal-list u-pc-only">
                                                                                                                                                                                                <li class="modal-list-item">
                                                        <button type="button" data-target="#countrysg" class="modal-list-country active" data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/sg.webp" type="image/webp">
                                    
                                </picture>
                                SINGAPORE
                            </button>
                            <ul class="modal-list-lang collapse" id="countrysg" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/sg/en" class="active">
                                        English
                                    </a>
                                </li>
                                                                
                                                                
                                                            </ul>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <button type="button" data-target="#countryth" class="modal-list-country " data-toggle="collapse" aria-expanded="false">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/th.webp" type="image/webp">
                                    
                                </picture>
                                ไทย
                            </button>
                            <ul class="modal-list-lang collapse" id="countryth" data-parent="#accordionCountryLang">
                                                                <li>
                                    <a href="https://www.owndays.com/th/th" class="">
                                        ภาษาไทย
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/en" class="">
                                        English
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/ja" class="">
                                        日本語
                                    </a>
                                </li>
                                                                <li>
                                    <a href="https://www.owndays.com/th/zh_cn" class="">
                                        中文 (简体)
                                    </a>
                                </li>
                                                            </ul>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/ph/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/ph.webp" type="image/webp">
                                    
                                </picture>
                                PHILIPPINES
                            </a>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/my/en" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/my.webp" type="image/webp">
                                    
                                </picture>
                                MALAYSIA
                            </a>
                                                    </li>
                                                                                                                                                                        <li class="modal-list-item">
                                                        <a href="https://www.owndays.com/id/in" class="modal-list-country ">
                                <picture>
                                    <source srcset="https://www.owndays.com/images/flags/id.webp" type="image/webp">
                                    
                                </picture>
                                INDONESIA
                            </a>
                                                    </li>
                                                                                                                        </ul>
                                        </div>
            </div>
        </div>
    </div>
</div>

    <!-- Scripts -->
    <script src="https://polyfill.io/v3/polyfill.min.js?features=Object.values%2CObject.entries%2CArray.prototype.find%2CString.prototype.includes%2CArray.prototype.includes%2CArray.prototype.flatMap"></script>
    <script src="https://www.owndays.com/web/js/active-nav-menu.js?v=1.1"></script>
    <script src="https://www.owndays.com/web/js/lazysizes.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
        <script>
        lazySizes.init();
        const baseUrl = "https://www.owndays.com"

        //IF IN LIFF CLIENT CANNOT ACCESS WEB NAMESPACE

        if (!Object.entries) {
            Object.entries = function(obj) {
                var ownProps = Object.keys(obj),
                    i = ownProps.length,
                    resArray = new Array(i); // preallocate the Array
                while (i--)
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];

                return resArray;
            };
        }
        if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, 'find', {
                value: function(predicate) {
                    // 1. Let O be ? ToObject(this value).
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }

                    var o = Object(this);

                    // 2. Let len be ? ToLength(? Get(O, "length")).
                    var len = o.length >>> 0;

                    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                    if (typeof predicate !== 'function') {
                        throw new TypeError('predicate must be a function');
                    }

                    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    var thisArg = arguments[1];

                    // 5. Let k be 0.
                    var k = 0;

                    // 6. Repeat, while k < len
                    while (k < len) {
                        // a. Let Pk be ! ToString(k).
                        // b. Let kValue be ? Get(O, Pk).
                        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                        // d. If testResult is true, return kValue.
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        // e. Increase k by 1.
                        k++;
                    }

                    // 7. Return undefined.
                    return undefined;
                },
                configurable: true,
                writable: true
            });
        }

        window.site_url = ''
    </script>
        <script src="https://www.owndays.com/web/js/jquery.easing.1.3.js" defer></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3.2/jquery.easing.min.js" integrity="sha512-qJw3EXcEMHpFae2o6eQmiDc1TACjjT7xMGnMcsmDFB55XiL/6SdZEsRv08wRR+OLJ7sijqHksLHDAlbB94glxg==" crossorigin="anonymous"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/picturefill/3.0.2/picturefill.min.js" integrity="sha512-Nh/FthCqOFq56kGp1DsNb6GKK29iIv2ZJc7Fylln1WRrWpeE5LjSBWeAp61dkBASDxZT12aL9mZyIrhsAqgRpw==" crossorigin="anonymous"></script>
    
    
    <script src="https://www.owndays.com/web/js/helper.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.sticky/1.0.4/jquery.sticky.min.js" integrity="sha512-QABeEm/oYtKZVyaO8mQQjePTPplrV8qoT7PrwHDJCBLqZl5UmuPi3APEcWwtTNOiH24psax69XPQtEo5dAkGcA==" crossorigin="anonymous"></script>
    <script src="https://cdn.xapping.com/libs.js"></script>
    <script>
        var uri = window.location.toString();
        if (uri.indexOf("#") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("#_=_"));
            window.history.replaceState({}, document.title, clean_uri);
        }
        // Header Sticky
        // $("header.l-header").sticky({
        //     topSpacing: 0,
        //     zIndex: 9999
        // });

        // Header Sticky
        // $(".c-information__sale-time").sticky({
        //     topSpacing: 0,
        //     zIndex: 9999,
        //     wrapperClassName: 'sticky-wrapper--sale-time'
        // });

        $('#main-body').show();

        function openMenu(evt, menuName) {
            var i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("tab__content");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("tab__link");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }
            document.getElementById(menuName).style.display = "flex";
            evt.currentTarget.className += " active";
        }

        function supportWebP() {
            var rv = $.Deferred(),
                img = new Image();
            img.onload = function() {
                rv.resolve();
            };
            img.onerror = function() {
                rv.reject();
            };
            img.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAIAAkA4JaQAA3AA/vshgAA=";
            return rv.promise();
        }

        supportWebP().then(function() {
            $('body').addClass('webp');
        }, function() {
            $('body').addClass('no-webp');
        });

        $('.l-header__navbar__inner.u-pc-only, #breadcrumb-list').one('mouseover', function() {
            $('#menu_products_glasses_toggle img').each(function () {
                lazySizes.loader.unveil($(this)[0])
            });
        });
    </script>
        <script>
        // handle suffix breadcrumb in profile page
        appendBreadcrumb( $('.is-active'))

        $('.profile-nav').on('click', function(){
            appendBreadcrumb(this)
        }) 
        function appendBreadcrumb(element) {
            var breadcrumb = $(element).data('breadcrumb')
            $('#suffix-breadcrumb').remove();
            if (breadcrumb) {
                $('#breadcrumb-list').append("<li id='suffix-breadcrumb'>"+ breadcrumb +"</li>")
            }
        }
    </script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/smooth-scroll/16.1.3/smooth-scroll.min.js"></script>
<script src="https://www.owndays.com/web/js/specials-mi-mollet.js"></script>
  
</body>

</html>`;

const MimolletCollectionHTML = () => {
  return (
    <>
      <ExternalResources />
      <div dangerouslySetInnerHTML={{ __html: html }} id="external-pages" />
    </>
  );
};

export default MimolletCollectionHTML;
